import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';

export const fetchMatches = createAsyncThunk(
    'matches/fetchMatches',
    async (tournamentId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/matches/${tournamentId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: error.message });
        }
    }
);

export const createMatch = createAsyncThunk(
    'matches/createMatch',
    async ({ slug, data }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`/${slug}/api/matches`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: error.message });
        }
    }
);

export const updateMatch = createAsyncThunk(
    'matches/updateMatch',
    async ({ slug, matchId, data }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`/${slug}/api/matches/${matchId}`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: error.message });
        }
    }
);

export const deleteMatch = createAsyncThunk(
    'matches/deleteMatch',
    async ({ slug, matchId }, { rejectWithValue }) => {
        try {
            await axios.delete(`/${slug}/api/matches/${matchId}`);
            return matchId;
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: error.message });
        }
    }
);

export const fetchStandings = createAsyncThunk(
    'matches/fetchStandings',
    async (tournamentId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/matches/${tournamentId}/standings`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { error: err.message });
        }
    }
)

const matchSlice = createSlice({
    name: 'matches',
    initialState: {
        matches: [],
        standings: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Matches
            .addCase(fetchMatches.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchMatches.fulfilled, (state, action) => { state.loading = false; state.matches = action.payload; })
            .addCase(fetchMatches.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

            // Create Match
            .addCase(createMatch.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(createMatch.fulfilled, (state, action) => { state.loading = false; state.matches.push(action.payload); })
            .addCase(createMatch.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

            // Update Match
            .addCase(updateMatch.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(updateMatch.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.matches.findIndex(m => m._id === action.payload._id);
                if (index !== -1) {
                    state.matches[index] = action.payload;
                }
            })
            .addCase(updateMatch.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

            // Delete Match
            .addCase(deleteMatch.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(deleteMatch.fulfilled, (state, action) => {
                state.loading = false;
                state.matches = state.matches.filter(m => m._id !== action.payload);
            })
            .addCase(deleteMatch.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

            // Fetch Standings
            .addCase(fetchStandings.fulfilled, (state, action) => {
                state.standings = action.payload;
            });
    },
});

export default matchSlice.reducer;
